import { vMaska } from 'maska';

export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.directive('maska', vMaska);
  },
});
